<template>
    <modal class="reserveEditModel" :isShow="isShow"  @keyup.esc="hide">
        <div class="header">
            <div class="title">
                预订单<span class="type" v-show="isEdit">{{isEditOrder?'编辑':'新建'}}</span>
            </div>
            <div class="date-box">{{ydDateText}} · {{phaseName}}</div>
            <div class="desk-box">
                共{{deskList.length}}桌: 
                <span class="desk-name" v-for="(item,index) in deskList" :key="index">
                   {{item.Desk_Name}}
                </span>
            </div>
        </div>
        <div class="modal-body" v-mouse-scroll ref="scroll">
            <div class="panel-box">
                <div class="title-box">
                    预订信息
                </div>
                <div class="tr-from">
                    <div class="lable-name"><span class="red">*</span>客户电话</div>
                    <div class="from-box">
                        <div class="from-input" style="width:430px">
                            <input-pattern :pattern="/^\d{0,16}$/" v-model="phone" placeholder="请输入电话" @keydown.enter="changePhone" @focus="isFocus=true" @blur="changePhone" :disabled="isEditOrder"/>
                            <div class="search-box" v-if="!preOrderId && isSearch">
                                <div class="search-list-box">
                                    <div class="li" v-for="item in clientList" :key="item" @click="clientClick(item)">
                                        <div class="search-inline-left">
                                            <div class="search-inline-phone">
                                                {{phoneHtml(item.Client_Mobile)}}
                                            </div>
                                            <div class="search-inline-name">{{item.Client_Name}}</div>
                                        </div>
                                        <div class="search-inline-vip">{{item.Client_LevelName}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tr-from tr-flex">
                    <div>
                        <div class="lable-name"><span class="red">*</span>客户姓名</div>
                        <div class="from-box">
                            <div class="from-input" style="width:405px">
                                <input type="text" v-model="name" placeholder="请输入姓名" :disabled="isEditOrder"/>
                            </div>
                            <div class="tag-box sex-box" @click="()=>{if(!isEditOrder) sex=!sex}">
                                <div class="tag" :class="{selected:sex}">先生</div>
                                <div class="tag" :class="{selected:!sex}">女士</div>
                            </div>
                        </div>
                    </div>
                    <div class="flex1">
                        <div class="lable-name"><span class="red">*</span>就餐人数</div>
                        <div class="from-box number-box">
                            <div class="bnt-jian" @click="()=>{if(isEdit)number>0&&number--;}"><i class="iconfont icon-jian"></i></div>
                            <div class="number"><input-pattern pattern="number" :dplaces="0" v-model="number" :max="99999" :disabled="!isEdit"/></div>
                            <div class="bnt-jia" @click="()=>{if(isEdit) number++}"><i class="iconfont icon-jia"></i></div>
                        </div>
                    </div>
                </div>
                <div class="tr-from tr-flex">
                    <div class="flex1">
                        <div class="lable-name"><span class="red">*</span>到店时间</div>
                        <div class="from-box">
                            <el-time-select class="select-time" :disabled="isEditOrder"
                                prefix-icon="iconfont icon-a-shijiankaishishijian1"
                                placeholder="请选择到店时间"
                                v-model="phaseTime"
                                :start="Base_BTime"
                                :step="Reserve_Interval"
                                :end="Base_ETime"
                                :clearable="false"
                            />
                        </div>
                    </div>
                    <div class="flex1">
                        <div class="lable-name"><span class="red">*</span>预订类型</div>
                        <div class="from-box">
                            <div class="flex1 tag-box" @click="()=>{if(!isEditOrder) type=type==1?2:1}">
                                <div class="tag" :class="{selected:type==1}">普通</div>
                                <div class="tag" :class="{selected:type==2}">宴会</div>
                            </div>
                        </div>
                    </div>
                    <div class="flex1" :style="{visibility:type==1?'hidden':''}">
                        <div class="lable-name">桌数</div>
                        <div class="from-box dexk-num-box">
                            <div class="from-input"><input-pattern v-model="deskNum" pattern="number" :disabled="!isEdit"/></div><span>桌，备</span>
                            <div class="from-input"><input-pattern v-model="reserveNum" pattern="number" :disabled="!isEdit"/></div>桌
                        </div>
                    </div>
                </div>
                <div class="tr-from tr-flex">
                    <div class="flex1">
                        <div class="lable-name">营销员</div>
                        <div class="from-box">
                            <div class="from-input"><input v-model="salerName" readonly/></div>
                            <!-- <el-select v-model="salerName" placeholder="请选择" disabled>
                                <el-option :value="salerName" :label="salerName"></el-option>
                            </el-select> -->
                        </div>
                    </div>
                    <div class="flex1">
                        <div class="lable-name">订单渠道</div>
                        <div class="from-box">
                            <el-select v-model="channelInfo" placeholder="请选择" :disabled="!isEdit">
                                <el-option :value="item" :label="item.label" 
                                    v-for="item in channelList" :key="item"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="flex1">
                        <div class="lable-name">消费类型</div>
                        <div class="from-box">
                            <el-select v-model="xfType" placeholder="请选择" :disabled="!isEdit" >
                                <el-option :value="item" :label="item.label" 
                                    v-for="item in xfTypeList" :key="item"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="tr-from tr-flex">
                    <div style="width:234.66px">
                        <div class="lable-name">餐标</div>
                        <div class="from-box from-input-select">
                            <div class="from-input"><input-pattern v-model="canBiaoMoney" pattern="money" type="text" placeholder="金额" :disabled="!isEdit"/></div>
                            <el-select class="unit-select" v-model="foodUnit" :disabled="!isEdit">
                                <el-option :value="item.value" :label="item.text" v-for="item in foodUnits" :key="item"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="flex1" v-if="!preOrderId">
                        <div class="lable-name">短信通知</div>
                        <div class="from-box">
                            <div class="tag-box" style="width:192px" @click="()=>{if(isEdit)isSendSms=!isSendSms}">
                                <div class="tag" :class="{selected:!isSendSms}">不发送</div>
                                <div class="tag" :class="{selected:isSendSms}">发送</div>
                            </div>
                            <div class="flex1" v-if="isSendSms">
                                <el-select v-model="smsTemp" placeholder="请选择短信模板" :disabled="!isEdit">
                                    <el-option :value="item.SmSModuleAutoid" :label="item.SmSModuleName" 
                                        v-for="item in tempSMSList" :key="item"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="panel-box">
                <div class="title-box">
                    可选设置
                </div>
                <div class="tr-from grid-box">
                    <div class="flex1">
                        <div class="td-title">
                            <div class="name">
                                配菜
                                <div class="text" v-show="!isPeiCai">开启后可为该预订配菜</div>
                            </div>
                            <el-switch v-model="isPeiCai" active-text="" active-color="#22983E" :disabled="!isEdit"/>
                        </div>
                        <div class="link-bnt" v-show="isPeiCai" @click="peiClick">
                            <span>去配菜</span><i class="iconfont">→</i>
                        </div>
                        <!-- <div class="content-box" v-show="isPeiCai">
                            <div class="tatal">
                                共10道菜，￥1,000
                            </div>
                            <div class="text">
                                凉菜4道 · 热菜4道 · 汤1道 · 主食1道
                            </div>
                        </div> -->
                    </div>
                    <div class="flex1">
                        <div class="td-title">
                            <div class="name">
                                定金
                                <div class="text" v-show="!isDingJin">开启后可收取客户定金</div>
                            </div>
                            <el-switch v-model="isDingJin" active-text="" active-color="#22983E" :disabled="!isEdit"/>
                        </div>
                        <div class="link-bnt" v-show="isDingJin && isEdit" @click="collectDepositShow=true" >
                            <span>收取定金</span><i class="iconfont">→</i>
                        </div>
                        <div class="content-box" v-show="isDingJin">
                            <div class="tatal">
                                共{{paymentDetail?.length||0}}笔 <span class="pay">微信支付：<span class="money">￥{{payMoney}}</span></span>
                            </div>
                            <!-- <div class="text" v-if="paymentDetail?.length>0">
                                {{new Date(paymentDetail[0].Pre_Time).Format("yyyy-MM-dd hh:mm")}} 收取
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="panel-box">
                <div class="title-box">
                    客户偏好
                </div>
                <div class="tr-from grid-box kh-lable-box">
                     <div class="flex1">
                        <div class="td-title">客户喜好</div>
                        <input-tag class="tag-box" v-model="lableList[1]" lableKey="LableName" :disabled="true"/>
                    </div>
                    <div class="flex1">
                        <div class="td-title">客户忌口</div>
                        <input-tag class="tag-box taboos" v-model="lableList[2]" lableKey="LableName" :disabled="true"/>
                    </div>
                    <div class="flex1">
                        <div class="td-title">客户标签</div>
                        <input-tag class="tag-box" v-model="lableList[0]" lableKey="LableName" :disabled="true"/>
                    </div>
                </div>
                <div class="tr-from">
                    <div class="lable-name">订单备注</div>
                    <div class="from-box">
                        <textarea v-model="remark" placeholder="请输入内容，100个汉字以内" maxlength="100" :disabled="!isEdit"></textarea>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-box">
            <button class="btn btn-cancel" @click="hide()">放弃</button>
            <button class="btn btn-confirm" v-show="isEdit" @click="confirm()">保存预订</button>
        </div>
        <!-- 收取定金 -->
        <modal-load :isShow="collectDepositShow" :isUnload="true">
            <collect-deposit-model :isShow="collectDepositShow" :data="paymentDetail" 
                @close="collectDepositShow=false" @confirm="depositConfirm"/>
        </modal-load>
    </modal>
</template>

<script>
import collectDepositModel from '../collectDepositModel/collectDepositModel.vue';
import {getLunar} from 'chinese-lunar-calendar';
export default {
    components: { 
        collectDepositModel
    },
    emits:["close","confirm"],
    props:{
        isShow:{
            type:Boolean,
            default:false
        },
        //传入的参数
        data:{
            type:Object,
            default:null
        }
    },
    data(){
        return {
            Reserve_Interval:"00:30",
            Base_BTime:"00:00",
            Base_ETime:"23:59",
            //渠道数据列表
            channelList:[],
            //消费类型
            xfTypeList:[],
            //电话记录 来源id
            TelAutoID:"",
            //预订单id
            preOrderId:"",
            /*预订日期*/
            ydDate:new Date().Format("yyyy-MM-dd"),
            //时段id
            phaseID:"",
            parentPhaseID:"",
            //时段名称
            phaseName:"",
            //时段时间
            phaseTime:"",
            ydDateText:'',
            //预订桌台
            reserveDeskList:[],
            //1为普通订单，2为宴会订单，
            type:1,
            //桌数
            deskNum:'',
            //备
            reserveNum:'',
            //人数
            number:'',
            //客户id
            Client_ID:null,
            //客户手机号
            phone:"",
            //客户姓名
            name:"",
            //客户性别 false:女，true:男
            sex:true,
            //客户等级
            levelID:"",
            levelName:"",
            //近30天销售次数
            TotalNum:0,
            //近30天销售桌均
            DeskAvgMoney:0,
            //近30天销售人均
            ManAvgMoney:0,
            //标签 切页
            lableType:1,
            //喜好 标签 0自定义 1喜好 2忌口
            lableList:[[],[],[]],
            /*标签*/
            tagList:[{}],
            //餐标
            canBiaoMoney:"",
            foodUnit:1,
            foodUnits:[
                { value: 2, text: "元/桌" },
                { value: 1, text: "元/人" },
            ],
            //订单来源
            channelInfo:{},
            //营销人员
            salerName:"",
            salerUserID:"",
            //消费类型
            xfType:{},
            //备注
            remark:"",
            //会员信息
            memberInfo:null,
            //预订单 详细信息
            Eat_PreAutoInfo:null,
            //是否短信通知
            isSendSms:false,
            //短信模板
            smsTemp:"",
            tempSMSList:[],
            //是否配菜
            isPeiCai:false,
            //是否定金
            isDingJin:false,
            //定金明细
            paymentDetail:[],
            //定金
            collectDepositShow:false,
            //已有预订单 是否可编辑
            IsCanUpdate:false,
            loading:false,
            //手机号 输入框 焦点
            isFocus:false,
            clientList:[]
        }
    },
    computed:{
        //预订桌台
        deskList(){
            if(this.type==2){//2为宴会订单
                return this.reserveDeskList.slice(0,1);
            }
            return this.reserveDeskList;
        },
        //定金金额
        payMoney(){
            let money=0;
            this.paymentDetail.forEach(it=>{
                money=Number((it.Payment_Money+money).toFixed(4));
            });
            return money;
        },
        //是否可编辑
        isEdit(){
            if(this.preOrderId && this.Eat_PreAutoInfo){//已有预订单， 有开台 或 全部取消的都不能在编辑
                //订单状态，0:未接单，1:已接单(未确认)，2:已接单(已确认未入座)，3:已入座，4:已结账，5:部分取消，6:全部取消
                if(([3,4,6]).includes(this.Eat_PreAutoInfo.Status) ){
                    return false;
                }
                //桌台状态，0:已预订待入座，1:已开台(已入座)，2:已结账，3:已退订(已取消)，10:已锁定，11:取消锁定
                else if(this.Eat_PreAutoInfo.ReserveDesks.some(it=> ([1,2]).includes(it.Eat_DeskState) )){
                    return false;
                }
                return this.IsCanUpdate;//已有预订单 是否可编辑
            }
            return true;
        },
        //编辑预订单时 是否是修改状态
        isEditOrder(){
            if(this.isEdit){
                if(this.preOrderId){
                    return true;
                }
                return false;
            }
            return true;
        },
        //客户检索框 是否显示
        isSearch(){
            return this.isFocus && this.phone && this.phone.length>=4 && this.clientList?.length>0;
        }
    },
    watch:{
        isShow(newVal){
            if(newVal){
                this.init();
            }
        },
        phone(){
            if(!this.preOrderId){
                this.phone=(this.phone||"").trim();
                if(this._time){
                    clearTimeout(this.time);
                }
                if(this.phone && this.phone.length>=4 && this.isFocus){
                    this.time=setTimeout(()=>{
                        this.loadClientList();
                    },100);
                }else{
                    if(!this.isFocus){
                        this.isFocus=true;
                    }
                    this.clientList=[];
                }
            }
        }
    },
    mounted(){
        //消费类型数据
        this.$cacheData.ConsumeTypes().then(d=>{
            const list=[];
            (d||[]).forEach(it=>{
                (it.ConsumeTypeList||[]).forEach(item=>{
                    list.push({
                        label:item.ConsumeType_Name,
                        value:item.ConsumeType_AutoID
                    })
                });
            });
            this.xfTypeList=list;
            console.log(this.xfTypeList)
        })
        //渠道数据
        this.$cacheData.OrderChannel().then(d=>{
            const list=[];
            (d||[]).forEach(it=>{
                (it.OrderChannelList||[]).forEach(item=>{
                    list.push({
                        value:item.OrderChannel_AutoID,
                        label:item.OrderChannel_Name
                    })
                });
            });
            this.channelList=list;
            console.log(this.channelList)
        })

        
        this.$nextTick(()=>{
            this.init();
        })
    },
    methods:{
        hide(){
            this.$emit("close");
        },
        peiClick(){
            this.$message.warning("配菜功能开发中，敬请期待！");
        },
        async init(){
            if(!this.isShow){return;}
            if(this.$refs.scroll){
                this.$nextTick(()=>{
                    this.$refs.scroll.scrollTop=0;
                })
            }
            //手机号 输入框 焦点
            this.isFocus=false;
            this.clientList=[];
            this.preOrderId=this.data?.preOrderId;
            this._oldPhone="";
            this.TelAutoID="";
            //清空数据
            this.ydDate=new Date().Format("yyyy-MM-dd");
            this.phaseID="";
            this.parentPhaseID="";
            this.phaseName="";
            this.phaseTime="";
            this.ydDateText="";
            this.reserveDeskList=[];
            this.type=1;
            this.deskNum="";
            this.reserveNum="";
            this.number="";
            this.Client_ID=null;
            this.phone="";
            //客户姓名
            this.name="";
            //客户性别 false:女，true:男
            this.sex=true;
            //客户等级
            this.levelID="";
            this.levelName="";
            //近30天销售次数
            this.TotalNum=0;
            //近30天销售桌均
            this.DeskAvgMoney=0;
            //近30天销售人均
            this.ManAvgMoney=0;
            //标签 切页
            this.lableType=1;
            //喜好 标签 0自定义 1喜好 2忌口
            this.lableList=[[],[],[]];
            //餐标
            this.canBiaoMoney="";
            this.foodUnit=this.foodUnits[0].value;
            //订单来源
            this.channelInfo={};
            //营销人员
            this.salerName="";
            this.salerUserID="";
            //消费类型
            this.xfType={};
            //备注
            this.remark="";
            //会员信息
            this.memberInfo=null;
            //预订单 详细信息
            this.Eat_PreAutoInfo=null;
            //是否短信通知
            this.isSendSms=false;
            //短信模板
            this.smsTemp="";
            //是否配菜
            this.isPeiCai=false;
            //是否定金
            this.isDingJin=false;
            //定金明细
            this.paymentDetail=[];
            this.Reserve_Interval="00:30";
            

            const userInfo=this.$auth.getUserInfo();
            if(userInfo){
                this.salerName=userInfo.Login_Name;
                this.salerUserID=userInfo.User_ID;
            }

            if(this.data?.Eat_PreAutoID){//编辑
                this.preOrderId=this.data.Eat_PreAutoID;
                this.loadData();
            }else{//新建
                this.phaseID=this.data?.phaseID;//时段id
                this.parentPhaseID=this.data?.parentPhaseID,
                this.phaseName=this.data?.phaseName;//时段名称
                this.phaseTime=this.data?.phaseTime;//时段时间
                this.reserveDeskList=this.data?.deskList||[];//桌台
                this.number=this.data?.personNum||1;//人数
                this.Base_BTime=this.data?.Base_BTime||"00:00"//预订可选时间范围 开始
                this.Base_ETime=this.data?.Base_ETime||"23:00"//预订可选时间范围 结束
                if(this.data?.Reserve_Interval>0){//预订间隔时间,单位分钟,默认30分钟
                    this.Reserve_Interval="00:"+("0"+this.data.Reserve_Interval).substring(("0"+this.data.Reserve_Interval).length-2);
                }
                this.setYDDate(this.data?.ydDate);
                await this.loadSmSModule();
                if(this.data?.phoneNumber){
                    this.$nextTick(()=>{
                        this.phone=this.data.phoneNumber.replaceAll("-","");
                        this.TelAutoID=this.data.TelAutoID;
                        this.$nextTick(()=>{
                            this.isFocus=false;
                        });
                        this.GetClientInfo(this.phone);
                    })
                }
            }

        },
        //修改当前日期
        setYDDate(Rpt_Date) {
            if (Rpt_Date) {
               
                const date = new Date(Rpt_Date);
                this.ydDate=date.Format("yyyy-MM-dd");
                let lunar = getLunar(date.getFullYear(), date.getMonth() + 1, date.getDate());
                this.ydDateText=`${date.Format('yyyy年 MM月 dd日')} (${lunar.dateStr}) 星期${('日一二三四五六')[date.getDay()]}`;
            }
        },
        phoneHtml(number){
            return number.replace(/(\d{3})(\d{4})(\d{4})/,(d,$1,$2,$3)=>{
                return $1+" "+$2+" "+$3;
            })
        },
        //选中客户
        clientClick(item){
            this.phone=item.Client_Mobile;
			this.isFocus=false;
            this.GetClientInfo(this.phone);
        },
        //输入手机号 检索客户
        changePhone(){
            if(this.isSearch && this.clientList.length>0){
                this.phone=this.clientList[0].Client_Mobile;
            }else{
                return;
            }
            this.isFocus=false;
            this.GetClientInfo(this.phone);
        },
        //检索客户 信息
        loadClientList(){
            if(this.loading){
                return ;
            }
            this.loading=true;
            const userInfo=this.$auth.getUserInfo(); //获取用户id
            const param={
                User_ID: userInfo.User_ID,
                Operator_Name: userInfo.Login_Name,
                DepartmentID:userInfo.Department_ID,
                SearchType:2,
                SearchText:(this.phone||"").trim(),//手机号模糊检索
                PageSize:3
            }
            this.$httpAES.reservePost("Bestech.CloudPos.Reserve.GetClients",param).then(d=>{
                this.loading=false;
                if (d.ResponseHeader.ResultCode != 0) {
                    console.log('获取失败:', d.ResponseHeader.ResultDesc);
                } else {
                    this.clientList= (d.ResponseBody||{}).Items||[];
                    console.log(this.clientList)
                }
            }).catch(e => {
                this.loading=false;
                console.log('请求失败:', e);
            });
        },
        //通过手机号获取客户信息
        async GetClientInfo(phoneNumber){
            if(this._load){
                return;
            }
            this._load=true;

            phoneNumber=(phoneNumber||"").trim();
            if(!/^\d{7,}$/.test(phoneNumber) || this._oldPhone==phoneNumber){
                return;
            }
            
           
            const loading = this.$loading({
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            let clientInfo=null;
            try{
                const param={
                    Client_Mobile:phoneNumber
                }
                clientInfo=await this.$httpAES.reservePost("Bestech.CloudPos.Reserve.GetClientInfo",param).then(d=>{
                    if (d.ResponseHeader.ResultCode != 0) {
                        throw {message:d.ResponseHeader.ResultDesc}
                    }else {
                        return d.ResponseBody;
                    }
                });
                this._oldPhone=phoneNumber;
            }catch(e){
                //TODO handle the exception
            }
            
            // try{//获取会员信息
            //     const param={
            //         Member_Type:2,//正品CRM3.0 会员
            //         SourceFrom:2,//业务来源，2:预定。
            //         Mobile:phoneNumber
            //     }
            //     await this.$httpAES.reservePost("Bestech.CloudPos.Reserve.GetMemberInfo",param).then(d=>{
            //         if (d.ResponseHeader.ResultCode != 0) {
            //             throw {errMsg:d.ResponseHeader.ResultDesc}
            //         }else {
            //             this.memberInfo=d;
            //             console.log(d);
            //         }
            //     });
            // }catch(e){
            //     this.memberInfo=null;
            // }
            
            
            this._load=false;
            loading?.close();
            if(clientInfo){
                this.setClientInfo(clientInfo);
            }else{
                if(this.Client_ID){//之前有 清空原有数据
                    this.setClientInfo({
                        Client_Name:this.name,
                        Client_Mobile:phoneNumber
                    });
                }else{
                    this.phone=phoneNumber;
                }
            }
            
        },
        //客户信息
        setClientInfo(info={}){
            this.Client_ID=info.Client_ID;
            this.phone=info.Client_Mobile;
            this.name=info.Client_Name;
            this.sex=info.Client_Sex;
            this.levelID=info.Client_LevelID;
            this.levelName=info.Client_LevelName;
            //近30天销售次数
            this.TotalNum=info.TotalNum||0;
            //近30天销售桌均
            this.DeskAvgMoney=info.DeskAvgMoney||0;
            //近30天销售人均
            this.ManAvgMoney=info.ManAvgMoney||0;
            //标签
            const list=[[],[],[]];
            if(info.ClientLableList){
                info.ClientLableList.forEach(it=>{
                    list[it.LableType].push(Object.assign({},it));
                })
            }
            this.lableList=list;
        },
        //清除客户手机号
        createClient(){
            this.phone="";
            this.memberInfo=null;
            if(this.Client_ID){//之前有 清空原有数据
                this.setClientInfo({
                    Client_Name:"",
                    Client_Mobile:""
                });
            }
        },
        //加载短信模板数据
        async loadSmSModule(){
            if(this.tempSMSList?.length>0){
                return;
            }
            const loading = this.$loading({
                text: "请求中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            //获取短信模板信息
            await this.$httpAES.reservePost("Bestech.CloudPos.GetSmSModuleInfo",{
                Eat_PreAutoID:this.preOrderId
            }).then(d => {
                loading.close();
                if (d.ResponseHeader.ResultCode != 0) {
                    this.$message.error(d.ResponseHeader.ResultDesc);
                } else {
                    this.tempSMSList = d.ResponseBody||[];
                    
                    if(!this.smsTemp && this.tempSMSList.length>0){
                        this.smsTemp=this.tempSMSList[0].SmSModuleAutoid;
                    }
                }
            }).catch(e => {
                loading.close();
                this.$message.error(e.message);
                console.log('请求失败:', e);
            });
        },
        //加载预订单
        async loadData(){
            if(this.loading){
                return;
            }
            this.loading=true;
            const userInfo=this.$auth.getUserInfo(); //获取用户id
            const param={
                User_ID: userInfo.User_ID,
                Operator_Name: userInfo.Login_Name,
                Eat_PreAutoID:this.preOrderId,
            }
            
            const loading = this.$loading({
                text: "请求中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            await this.$httpAES.reservePost("Bestech.CloudPos.Reserve.GetOrderInfo",param).then(d=>{
                loading.close();
                this.loading=false;
                if (d.ResponseHeader.ResultCode != 0) {
                    this.$message.error(d.ResponseHeader.ResultDesc);
                    this.hide();
                }else{
                    const info=d.ResponseBody;
                    this.Eat_PreAutoInfo=info;
                    this.preOrderId=info.Eat_PreAutoID;
                    this.ydDate=new Date(info.Eat_PreDate).Format("yyyy-MM-dd");//用餐日期
                    this.setYDDate(this.ydDate);
                    this.phaseID=info.Eat_PreChildPhaseID;//用餐轮次ID
                    this.parentPhaseID=info.Eat_PrePhaseID;//用餐时段ID
                    this.phaseName=info.Eat_PreChildPhaseName||"";//时段名称
                    this.phaseTime=new Date(info.Eat_PreTime).Format("hh:mm");//时段时间
                    
                    this.number=info.Eat_ManNum;//预定人数
                    this.type=info.Order_Type;//1为普通订单，2为宴会订单，
                    this.deskNum=info.DeskNum;//桌数
                    this.reserveNum=info.backDeskNum;//备桌数
                    this.Client_ID=info.Client_ID;
                    this.name=info.Cstm_Name;
                    this.phone=info.Cstm_Mobile;
                    this.sex=info.Cstm_Sex;
                    this.levelID=info.Client_LevelID;
                    this.levelName=info.Client_LevelName;
                    this.foodUnit=info.StandMoneyType||2;
					this.canBiaoMoney=info.StandMoney||0;
                    this.IsCanUpdate=info.IsCanUpdate;//已有预订单 是否可编辑
                    
                    //近30天销售次数
                    this.TotalNum=info.TotalNum||0;
                    //近30天销售桌均
                    this.DeskAvgMoney=info.DeskAvgMoney||0;
                    //近30天销售人均
                    this.ManAvgMoney=info.ManAvgMoney||0;
                    if(info.ReserveChannel_ID){//订单来源渠道
                        this.channelInfo={
                            value:info.ReserveChannel_ID,
                            lable:info.ReserveChannel_Name
                        }
                    }
                    
                    if(info.XfTypeId){//消费类型
                        this.xfType={
                            value:info.XfTypeId,
                            lable:info.XfType_Name
                        }
                    }
                    //标签
                    const list=[[],[],[]];
                    if(info.ClientLableList){
                        info.ClientLableList.forEach(it=>{
                            list[it.LableType].push(Object.assign({},it));
                        })
                    }
                    this.lableList=list;
                    
                    //定金
                    if((info.ReserveOrderPaymentDetails||[]).length>0){
                        this.isDingJin=true;
                        this.paymentDetail=info.ReserveOrderPaymentDetails;
                    }
                    
                    this.salerName=info.Eat_Sales;
                    this.salerUserID=info.Eat_SalesID;
                    this.remark=info.Eat_Bz;
                    //过滤已退的
                    this.reserveDeskList=info.ReserveDesks.filter(it => it.Eat_DeskState != 3).map(it=>{
                        return {
                            Desk_ID:it.Eat_DeskID,
                            Desk_Name:it.Eat_DeskName,
                        }
                    });
                    
                    
                }
            }).catch(e => {
                loading.close();
                this.loading=false;
                this.$message.error(e.message);
                this.hide();
                console.log('请求失败:', e);
            });
        },
        //保存 是否发送短信
        confirm(){
            if(!this.ydDate){
                this.$message.warning("预订日期不能为空");
                return;
            }
            if(!this.phaseID){
                this.$message.warning("预订时段不能为空");
                return;
            }
            if(!this.phaseTime){
                this.$message.warning("预订时间不能为空");
                return;
            }
            if(!(this.number>0)){
                this.$message.warning("请输入预订人数");
                return;
            }
            if(!this.deskList || this.deskList.length==0){
                this.$message.warning("预订桌台不能为空");
                return;
            }
            
            const userInfo=this.$auth.getUserInfo(); //获取用户id
            const info={
                Eat_PreAutoID:this.preOrderId,
                TelAutoID:this.TelAutoID,
                Eat_PreDate:this.ydDate,//用餐日期
                Eat_PreChildPhaseID:this.phaseID,//用餐轮次ID
                Eat_PrePhaseID:this.parentPhaseID,//用餐时段ID
                Eat_PreTime:this.ydDate+" "+this.phaseTime+":00",
                Eat_ManNum:this.number,//预定人数
                Order_Type:this.type||1,//1为普通订单，2为宴会订单，
                ReserveDesks:this.deskList.map(it=>{return {Eat_DeskID:it.Desk_ID}}),//预定桌台ID列表
                Cstm_Mobile:this.phone.trim(),
                Cstm_Name:this.name.trim(),
                Cstm_Sex:this.sex,
                Client_LevelID:this.levelID,//客户等级ID
                ReserveChannel_ID:(this.channelInfo||{}).value,//订单来源渠道
                XfTypeId:(this.xfType||{}).value,//消费类型
                Eat_SalesID: this.salerUserID, //销售员ID
				Eat_Sales: this.salerName, //销售员名称
                Eat_Bz:this.remark,
                // //配菜金额类型，1:按人均金额配菜，2:按桌均金额配菜
                StandMoneyType:this.foodUnit||2,
                // //配菜金额
                StandMoney:this.canBiaoMoney||0,
                // ReserveOrderConsumes:[],//预点单消费菜品明细
            }
            // if(!info.ReserveChannel_ID){
            //     this.$message.warning("请选择订单渠道");
            //     return;
            // }
            // if(!info.XfTypeId){
            //     this.$message.warning("请选择消费类型");
            //     return;
            // }
            if(!info.Cstm_Mobile){
                this.$message.warning("请输入手机号");
                return;
            }
            if(!/^\d{7,}$/.test(info.Cstm_Mobile)){
                this.$message.warning("请输入正确的手机号");
                return;
            }
            
            if(!info.Cstm_Name){
                this.$message.warning("请输入客户姓名");
                return;
            }
            if(this.isDingJin){
                info.ReserveOrderPaymentDetails=this.paymentDetail;//预点单定金明细
            }
            //客户标签列表
            info.ClientLableList=[];
            this.lableList.forEach((arr,index)=>{
                arr.forEach(it=>{
                    if(it.AutoID){
                        info.ClientLableList.push({
                            MER_ID:0,
                            AutoID:it.AutoID,
                            LableType:it.LableType,
                            LableName:it.LableName,
                            CstmLableAutoID:it.CstmLableAutoID||""
                        })
                    }else{
                        info.ClientLableList.push({
                            MER_ID:0,
                            LableType:index,
                            LableName:it.LableName,
                            CstmLableAutoID:it.CstmLableAutoID||""
                        })
                    }
                })
            })
            
            if(info.Order_Type==2){//2为宴会订单，
                info.DeskNum=Number(this.deskNum);//桌数
                info.backDeskNum=Number(this.reserveNum);// 备桌数
                if(info.ReserveDesks && info.ReserveDesks.length>0){
                    info.ReserveDesks=[info.ReserveDesks[0]];
                }
            }else{
                info.DeskNum=info.ReserveDesks.length;//桌数
            }

            if(this.isSendSms){//是否发短信
                if(!this.smsTemp){
                    this.$alert(this.fanYi("请选择短信模板"));
                    return;
                }
                info.SmSModuleAutoid=this.smsTemp;
            }
            
            const param={
                User_ID:userInfo.User_ID,
                Operator_Name:userInfo.Login_Name,
                ReserveOrderInfo:info,//预订单信息
            }
            let methodName="Bestech.CloudPos.Reserve.SendReserveOrder";
            if(this.preOrderId){//修改
                methodName="Bestech.CloudPos.Reserve.ModifyReserveOrder";
            }
            
            if(this._loading){
                return;
            }
            this._loading=true;
            const loading = this.$loading({
                text: "数据提交中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            return this.$httpAES.reservePost(methodName,param).then(d=>{
                loading.close();
                this._loading=false;
                if (d.ResponseHeader.ResultCode != 0) {
                    this.$message.error(d.ResponseHeader.ResultDesc);
                }else{
                    this.$message.success("保存成功");
                    this.$emit("confirm",d.ResponseBody);
                    this.hide();
                }
            }).catch(e => {
                loading.close();
                this._loading=false;
                this.$alert(e.message, "提示", {confirmButtonText: "确定"});
                console.log('请求失败:', e);
            });
        },
        //客户定金
        depositConfirm(data){
            this.paymentDetail=data;
            this.collectDepositShow=false;
        }
    }
}
</script>

<style lang="scss">
@import "./reserveEditModel.scss";
</style>